<script>
/* eslint-disable max-len */
// Components
import {
  VTimelineItem, VCard, VCardText, VRow, VChip,
} from 'vuetify/lib';

export default {
  name: 'OrsTimelineItem',
  extends: VTimelineItem,
  props: {
    color: {
      type: String,
      default: 'teal',
    },
    title: {
      type: String,
      default: null,
    },
    status: {
      type: String,
      default: null,
    },
  },
  render(h) {
    const def = this.$scopedSlots.default ? this.$scopedSlots.default(this.color) : [];
    const footer = this.$scopedSlots.footer ? this.$scopedSlots.footer(this.color) : [];
    const titleClass = [
      'ors-tml-i-title',
      [`${this.color}--text`],
    ];
    const borderClass = [
      'ors-tml-i-border-inner',
      this.color,
    ];
    const OrsTimelineItemInnerStatus = () => this.status && (
    <VChip
      class='ors-tml-i-title-status'
      label
      x-small
      color={this.color}
      text-color="white">
        {this.status}
    </VChip>
    );
    const OrsTimelineItemInnerTitle = () => this.title && (
    <div class={titleClass.join(' ')}>
      {this.title}
      <OrsTimelineItemInnerStatus />
    </div>
    );

    const OrsTimelineItemInner = () => (
       <div class="v-timeline-item__body">
          <VCard class="elevation-2">
            <div class='ors-tml-i-border'>
              <div class={borderClass} />
            </div>
            <VCardText>
              <OrsTimelineItemInnerTitle />
              {def}
              <VRow justify="center">
                {footer}
              </VRow>
            </VCardText>
            {this.genDivider()}
          </VCard>
       </div>
    );
    const children = [
      h(OrsTimelineItemInner),
      this.genDivider(),
    ];

    // Disable opposite
    // const { opposite } = this.$slots;
    // if (opposite) {
    //   children.push(this.genOpposite());
    // }

    return h('div', {
      staticClass: 'v-timeline-item',
      class: Object.assign({
        'v-timeline-item--fill-dot': this.fillDot,
        'v-timeline-item--before': this.timeline.reverse ? this.right : this.left,
        'v-timeline-item--after': this.timeline.reverse ? this.left : this.right,
        'ors-tml-i': true,
      }, this.themeClasses),
    }, children);
  },
};
</script>

<style lang="stylus" scoped>
.ors-tml-i {

  /deep/ .v-card {
    position: relative;

    // &:not(.v-card--flat) {
    //   &:before,
    //   &:after {
    //     content: '';
    //     position: absolute;
    //     border-top: 10px solid transparent;
    //     border-bottom: 10px solid transparent;
    //     border-right: 10px solid rgba();
    //     top: calc(50% - 10px);
    //   }

    //   &:after {
    //     border-right-color: inherit;
    //   }

    //   &:before {
    //     top: calc(50% - 12px);
    //   }
    // }

    .ors-tml-i-border {
      position: absolute;
      overflow: hidden;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 10px;

      .ors-tml-i-border-inner {
        position: absolute;
        display: block;
        right: 0;
        height: 100%;
        width: 4px;
      }
    }

    .ors-tml-i-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid;
      font-size: 16px;
      font-weight: 500;
      font-family: 'Encode Sans', sans-serif;

      .ors-tml-i-title-status {
        text-transform: uppercase;
      }
    }

    .v-input .v-input__slot {
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
    }

    .v-input .v-messages {
      display: none;
    }
  }
}
</style>

<style lang="stylus">
@media screen and (min-width: 960px) {
  .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i.v-timeline-item:nth-child(even):not(.v-timeline-item--after) .ors-tml-i-border .ors-tml-i-border-inner,
  .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .ors-tml-i.v-timeline-item--before .ors-tml-i-border .ors-tml-i-border-inner {
    right: auto;
    left: 0;
  }
}
</style>
